function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16 4c-.23 0-.45.091-.613.254l-12.68 12.68a1 1 0 01-1.414-1.414l12.68-12.68a2.867 2.867 0 014.055 0l12.68 12.68a1 1 0 01-1.415 1.414l-12.68-12.68A.867.867 0 0016 4z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 18a1 1 0 112 0v9.5a.5.5 0 00.5.5h17a.5.5 0 00.5-.5V18a1 1 0 112 0v10.5a1.5 1.5 0 01-1.5 1.5h-19A1.5 1.5 0 015 28.5V18z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.697 22.682a1 1 0 001.414 0l2.828-2.828 1.415 1.414a1 1 0 001.414 0l3.535-3.536a1 1 0 00-1.414-1.414l-2.828 2.828-1.415-1.414a1 1 0 00-1.414 0l-3.535 3.536a1 1 0 000 1.414z",
  fill: "currentColor"
})));